import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
} from '@mui/material';

const Navbar: React.FC = () => {
  return (
    <AppBar position="static" color="primary" elevation={0}>
      <Toolbar>
        <Typography
          variant="h6"
          component="a"
          href="https://media.tenor.com/n8DB4bmpduIAAAAM/yeah-bwoi-grin.gif"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: 700,
            fontFamily: 'Fira Code, monospace',
            '&:hover': {
              opacity: 0,
            },
          }}
        >
          firewall was right to be scared
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            color="inherit"
            href="https://hits.sh/ripdspace.netlify.app.svg?view=total&label=views&color=2f21e6"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontFamily: 'Fira Code, monospace',
              fontSize: '0.5rem',
              textTransform: 'none',
              padding: '4px 8px',
            }}
          >
            views (if you care)
          </Button> 
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 